module.exports = __webpack_public_path__ + "img/buy-now-btn.c62c56a7.svg";